import { Product } from '@ikea-aoa/component-view-3d';
import { Action } from 'redux';

import { ArmrestsByCover } from 'sofa-reborn-react';

// State
export interface ArmrestState {
	armrests: ArmrestsByCover | null;
	selectedArmrest: Product | null;
}

// Actions
export const SET_ARMRESTS = 'SET_ARMRESTS';
export const SET_SELECTED_ARMREST = 'SET_SELECTED_ARMREST';

interface SetArmrests extends Action {
	type: typeof SET_ARMRESTS;
	value: ArmrestsByCover;
}

interface SetSelectedArmrest extends Action {
	type: typeof SET_SELECTED_ARMREST;
	value: Product | null;
	track: boolean;
}

export type ArmrestStateActions = SetArmrests | SetSelectedArmrest;
